import { useDemo } from '../contexts/DemoContext';

import { Badge } from '@/components/ui/Badge';
import { Card, CardContent } from '@/components/ui/Card';
import { useAuth } from '@/contexts/AuthContext';
import { mountProductTags, priceFormatterV2 } from '@/lib/utils';
import { Product } from '@/services/ProductsService';

interface ProductCardProps {
  product: Product;
}

export function ProductCard({ product }: ProductCardProps) {
  const { user } = useAuth();

  const { handleProduct } = useDemo();

  const tags = mountProductTags(product);

  return (
    <div
      className="block cursor-pointer"
      onClick={() => handleProduct(product.id.toString())}
    >
      <Card className="group relative cursor-pointer overflow-hidden transition-all hover:shadow-md">
        {tags && tags.length > 0 && (
          <ul className="absolute left-2 top-2 z-10">
            {tags.map((tag) => (
              <li key={tag}>
                <Badge className="bg-green-500">{tag}</Badge>
              </li>
            ))}
          </ul>
        )}

        <div className="relative aspect-[3/4] overflow-hidden bg-muted/30">
          <img
            src={product.image1 || '/placeholder.svg'}
            alt={product.name}
            className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
          />
        </div>
        <CardContent className="space-y-3 p-4">
          <div>
            <h3 className="mb-1 line-clamp-1 font-medium text-foreground">
              {product.name}
            </h3>

            <p className="text-sm text-muted-foreground">
              {product.visionCategoryName}
            </p>
          </div>

          <div className="pt-2">
            <span className="text-lg font-medium text-primary">
              {priceFormatterV2(
                Number(product.salePrice),
                user!.customer.language,
                user!.customer.platform,
              )}
            </span>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
